import { IAsset } from "@/v1/components/pages/GameDetail/components/AssetsTab/types/Asset.interface";
import { AssetStatus } from "@/v1/components/pages/GameDetail/components/AssetsTab/utils/constants";
import debounce from "@/v1/utils/debounce";

import { StateType } from "../useRequestsStore";

import { MIN_DOWNLOAD_PERCENTAGE } from "./constants";

export const handleRequestProgress = (asset: IAsset, { set }: StateType) =>
  debounce((progress: ProgressEvent) => {
    if (progress.total) {
      const percentCompleted = Math.floor((progress.loaded * 100) / progress.total);

      requestAnimationFrame(() => {
        const requestPecentage =
          percentCompleted < MIN_DOWNLOAD_PERCENTAGE ? MIN_DOWNLOAD_PERCENTAGE : percentCompleted;

        set(({ queue }) => ({
          queue: queue.map(queueAsset =>
            queueAsset.id === asset.id && queueAsset.status === AssetStatus.IN_PROGRESS
              ? { ...queueAsset, requestPecentage }
              : queueAsset,
          ),
        }));
      });
    }
  }, 60);
